import { mixpanel } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES, MIXPANEL_PAGE_NAMES } from '../../../../../shared/mixpanel';
import { Location } from '../../shared/constants';
import { getCommonStores } from '../../utils/getCommonStores';

export const reportAddToFavorites = (variationPosition: number, location: Location) => {
    mixpanel.track('Logo Maker - Choose Variation - Add to Favorites', {
        ...getCommonStores(),
        [MIXPANEL_EVENT_PROPERTIES.PAGE_NAME]: MIXPANEL_PAGE_NAMES.CHOOSE_VARIATION,
        [MIXPANEL_EVENT_PROPERTIES.LOCATION]: location,
        [MIXPANEL_EVENT_PROPERTIES.VARIATION_POSITION]: variationPosition,
    });
};

reportAddToFavorites.Location = Location;
